import { get } from 'lodash';
import { bicyclesLabel, bicyclesUrl, bicyclesPath, bicyclesGridName } from '@modules/bicycles/BicyclesGrid';
import { employeesLabel, employeesUrl, employeesPath, employeesGridName } from '@modules/employees/EmployeesGrid';
import { eventsLabel, eventsUrl, eventsPath, eventsGridName } from '@modules/events/EventsGrid';
import { delictsLabel, delictsUrl, delictsPath, delictsGridName } from '@modules/delicts/DelictsGrid';
import { dogsLabel, dogsUrl, dogsPath, dogsGridName } from '@modules/dogs/DogsGrid';
import { errorsLabel, errorsUrl, errorsPath, errorsGridName } from '@modules/errors/ErrorsGrid';
import { dayplansLabel, dayplansUrl, dayplansPath, dayplansGridName } from '@modules/hr-dayplans/DayplansGridSingle';
import {
  requestsHolidayLabel,
  requestsHolidayUrl,
  requestsHolidayPath,
  requestsHolidayGridName
} from '@modules/hr-requests/holidays/RequestsHolidayGrid';
import {
  requestsPayLabel,
  requestsPayUrl,
  requestsPayPath,
  requestsPayGridName
} from '@modules/hr-requests/pays/RequestsPayGrid';
import {
  shiftsCyclesLabel,
  shiftsCyclesUrl,
  shiftsCyclesPath,
  shiftsCyclesGridName
} from '@modules/hr-shift-cycles/ShiftCyclesGrid';
import { shiftsLabel, shiftsUrl, shiftsPath, shiftsGridName } from '@modules/hr-shifts/ShiftsGrid';
import {
  calendarsLabel,
  calendarsUrl,
  calendarsPath,
  calendarsGridName
} from '@modules/hr-templates/calendars/CalendarsGrid';
import { daysLabel, daysUrl, daysPath, daysGridName } from '@modules/hr-templates/days/DaysGrid';
import { periodsLabel, periodsUrl, periodsPath, periodsGridName } from '@modules/hr-templates/periods/PeriodsGrid';
import { weeksLabel, weeksUrl, weeksPath, weeksGridName } from '@modules/hr-templates/weeks/WeeksGrid';
import {
  workPositionsLabel,
  workPositionsUrl,
  workPositionsPath,
  workPositionsGridName
} from '@modules/hr-workPositions/WorkPositionsGrid';
import { claimsLabel, claimsUrl, claimsPath, claimsGridName } from '@modules/hr-workTimes/claim/ClaimsGrid';
import {
  inventoryCardsLabel,
  inventoryCardsUrl,
  inventoryCardsPath,
  inventoryCardsGridName
} from '@modules/inventoryCards/InventoryCardsGrid';
import { jobsLabel, jobsUrl, jobsPath, jobsGridName } from '@modules/jobs/JobsGrid';
import { protocolsLabel, protocolsUrl, protocolsPath, protocolsGridName } from '@modules/protocols/ProtocolsGrid';
import { repairsLabel, repairsUrl, repairsPath, repairsGridName } from '@modules/repairs/RepairsGrid';
import { reportsLabel, reportsUrl, reportsPath, reportsGridName } from '@modules/reports/ReportsGrid';
import {
  rolesAssignLabel,
  rolesAssignUrl,
  rolesAssignPath,
  rolesAssignGridName
} from '@modules/roles-assing/RolesAssignGrid';
import {
  rolesCreateLabel,
  rolesCreateUrl,
  rolesCreatePath,
  rolesCreateGridName
} from '@modules/roles-create/RolesCreateGrid';
import { tasksLabel, tasksUrl, tasksPath, tasksGridName } from '@modules/tasks/TasksGrid';
import { ticketsLabel, ticketsUrl, ticketsPath, ticketsGridName } from '@modules/tickets/TicketsGrid';
import { tripsLabel, tripsUrl, tripsPath, tripsGridName } from '@modules/trips/TripsGrid';
import {
  wantedPersonLabel,
  wantedPersonUrl,
  wantedPersonPath,
  wantedPersonGridName
} from '@modules/wantedPersons/WantedPersonsGrid';
import {
  wantedVehiclesLabel,
  wantedVehiclesUrl,
  wantedVehiclesPath,
  wantedVehiclesGridName
} from '@modules/wantedVehicles/WantedVehiclesGrid';
import { dictionaryTemplates } from '@modules/dictionary/_dictionaryTemplates';
import {
  tasksCode,
  dogsCode,
  bicyclesCode,
  hrCode,
  warehousesCode,
  tripsCode,
  wantedPersonCode,
  wantedVehiclesCode
} from 'src/moduleCodes';
import {
  eventsPermission,
  delictsPermission,
  tasksPermission,
  employeesPermission,
  ticketsPermission,
  dogsPermission,
  bicyclesPermission,
  hrRequestsPermission,
  hrWorkTimesPermission,
  hrDayplansPermission,
  hrShiftsPermission,
  hrWorkPositionsPermission,
  warehouseInventoryCardsPermission,
  warehouseProtocolsPermission,
  tripsPermission,
  wantedPermission,
  repairsPermission,
  reportsPermission,
  administrationPermission,
  dictionariesPermission
} from 'src/permissions';

export const globalSearchDictionaryAgendas: Array<{
  label: string;
  url: string;
  path: string;
  gridName?: string;
  moduleCodes?: Array<string>;
  permissions: Array<string>;
}> = Object.keys(dictionaryTemplates).map(key => ({
  label: get(dictionaryTemplates, `${key}.title`),
  url: '/metropolis/api/' + get(dictionaryTemplates, `${key}.url`),
  path: `/dictionary/${key}`,
  permissions: [dictionariesPermission]
}));

export const globalSearchAgendas: Array<{
  label: string;
  url: string;
  path: string;
  permissions: Array<string>;
  gridName?: string;
  moduleCodes?: Array<string>;
}> = [
  {
    label: eventsLabel,
    url: eventsUrl,
    path: eventsPath,
    gridName: eventsGridName,
    permissions: [eventsPermission]
  },
  {
    label: delictsLabel,
    url: delictsUrl,
    path: delictsPath,
    gridName: delictsGridName,
    permissions: [delictsPermission]
  },
  {
    label: tasksLabel,
    url: tasksUrl,
    path: tasksPath,
    moduleCodes: [tasksCode],
    gridName: tasksGridName,
    permissions: [tasksPermission]
  },
  {
    label: employeesLabel,
    url: employeesUrl,
    path: employeesPath,
    gridName: employeesGridName,
    permissions: [employeesPermission]
  },
  {
    label: ticketsLabel,
    url: ticketsUrl,
    path: ticketsPath,
    gridName: ticketsGridName,
    permissions: [ticketsPermission]
  },
  {
    label: dogsLabel,
    url: dogsUrl,
    path: dogsPath,
    moduleCodes: [dogsCode],
    gridName: dogsGridName,
    permissions: [dogsPermission]
  },
  {
    label: bicyclesLabel,
    url: bicyclesUrl,
    path: bicyclesPath,
    moduleCodes: [bicyclesCode],
    gridName: bicyclesGridName,
    permissions: [bicyclesPermission]
  },
  {
    label: requestsPayLabel,
    url: requestsPayUrl,
    path: requestsPayPath,
    moduleCodes: [hrCode],
    gridName: requestsPayGridName,
    permissions: [hrRequestsPermission]
  },
  {
    label: requestsHolidayLabel,
    url: requestsHolidayUrl,
    path: requestsHolidayPath,
    moduleCodes: [hrCode],
    gridName: requestsHolidayGridName,
    permissions: [hrRequestsPermission]
  },
  {
    label: claimsLabel,
    url: claimsUrl,
    path: claimsPath,
    moduleCodes: [hrCode],
    gridName: claimsGridName,
    permissions: [hrWorkTimesPermission]
  },
  {
    label: periodsLabel,
    url: periodsUrl,
    path: periodsPath,
    moduleCodes: [hrCode],
    gridName: periodsGridName,
    permissions: [hrWorkTimesPermission]
  },
  {
    label: daysLabel,
    url: daysUrl,
    path: daysPath,
    moduleCodes: [hrCode],
    gridName: daysGridName,
    permissions: [hrWorkTimesPermission]
  },
  {
    label: weeksLabel,
    url: weeksUrl,
    path: weeksPath,
    moduleCodes: [hrCode],
    gridName: weeksGridName,
    permissions: [hrWorkTimesPermission]
  },
  {
    label: calendarsLabel,
    url: calendarsUrl,
    path: calendarsPath,
    moduleCodes: [hrCode],
    gridName: calendarsGridName,
    permissions: [hrWorkTimesPermission]
  },
  {
    label: dayplansLabel,
    url: dayplansUrl,
    path: dayplansPath,
    moduleCodes: [hrCode],
    gridName: dayplansGridName,
    permissions: [hrDayplansPermission]
  },
  {
    label: shiftsLabel,
    url: shiftsUrl,
    path: shiftsPath,
    moduleCodes: [hrCode],
    gridName: shiftsGridName,
    permissions: [hrShiftsPermission]
  },
  {
    label: shiftsCyclesLabel,
    url: shiftsCyclesUrl,
    path: shiftsCyclesPath,
    moduleCodes: [hrCode],
    gridName: shiftsCyclesGridName,
    permissions: [hrShiftsPermission]
  },
  {
    label: workPositionsLabel,
    url: workPositionsUrl,
    path: workPositionsPath,
    moduleCodes: [hrCode],
    gridName: workPositionsGridName,
    permissions: [hrWorkPositionsPermission]
  },
  {
    label: inventoryCardsLabel,
    url: inventoryCardsUrl,
    path: inventoryCardsPath,
    moduleCodes: [warehousesCode],
    gridName: inventoryCardsGridName,
    permissions: [warehouseInventoryCardsPermission]
  },
  {
    label: protocolsLabel,
    url: protocolsUrl,
    path: protocolsPath,
    moduleCodes: [warehousesCode],
    gridName: protocolsGridName,
    permissions: [warehouseProtocolsPermission]
  },
  {
    label: tripsLabel,
    url: tripsUrl,
    path: tripsPath,
    moduleCodes: [tripsCode],
    gridName: tripsGridName,
    permissions: [tripsPermission]
  },
  {
    label: wantedPersonLabel,
    url: wantedPersonUrl,
    path: wantedPersonPath,
    moduleCodes: [wantedPersonCode],
    gridName: wantedPersonGridName,
    permissions: [wantedPermission]
  },
  {
    label: wantedVehiclesLabel,
    url: wantedVehiclesUrl,
    path: wantedVehiclesPath,
    moduleCodes: [wantedVehiclesCode],
    gridName: wantedVehiclesGridName,
    permissions: [wantedPermission]
  },
  {
    label: repairsLabel,
    url: repairsUrl,
    path: repairsPath,
    gridName: repairsGridName,
    permissions: [repairsPermission]
  },
  {
    label: reportsLabel,
    url: reportsUrl,
    path: reportsPath,
    gridName: reportsGridName,
    permissions: [reportsPermission]
  },
  {
    label: errorsLabel,
    url: errorsUrl,
    path: errorsPath,
    gridName: errorsGridName,
    permissions: [administrationPermission]
  },
  {
    label: rolesCreateLabel,
    url: rolesCreateUrl,
    path: rolesCreatePath,
    gridName: rolesCreateGridName,
    permissions: [administrationPermission]
  },
  {
    label: rolesAssignLabel,
    url: rolesAssignUrl,
    path: rolesAssignPath,
    gridName: rolesAssignGridName,
    permissions: [administrationPermission]
  },
  {
    label: jobsLabel,
    url: jobsUrl,
    path: jobsPath,
    gridName: jobsGridName,
    permissions: [administrationPermission]
  },

  ...globalSearchDictionaryAgendas
];



// WEBPACK FOOTER //
// ./src/components/sidebar/globalSearch/_globalSearchEnums.ts